import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthProp, initialState } from './Auth.initialState';

import { updateUserAccountAction } from './Auth.actions';
import { createReducerBuilder } from '../../utils/reduxToolkit';

const reducerBuilder = createReducerBuilder<AuthProp>();

const handlePending = (state: AuthProp) => {
  state.isLoader = true;
};

const handleFulfilled = (
  state: AuthProp,
  payload: any,
  successMessage: string
) => {
  state.isLoader = false;
  if (payload?.data) {
    state.userData = { ...payload.data.data[0] };
  }
};

const handleRejected = (state: AuthProp, payload: any) => {
  state.isLoader = false;
  console.error('Update user failed', payload);
};

const updateUserReducer = reducerBuilder(updateUserAccountAction, {
  pending: handlePending,
  fulfilled: (state, { payload }) =>
    handleFulfilled(state, payload, payload?.data?.message),
  rejected: handleRejected,
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<any>) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    setToken: (state, action: PayloadAction<any>) => {
      state.token = action.payload;
    },

    logout: (state) => {
      state.userData = { ...initialState.userData };
    },
  },
  extraReducers: (builder) => {
    updateUserReducer(builder);
  },
});
export const { logout, setUserData, setToken } = authSlice.actions;

export default authSlice.reducer;
